import React from "react";

const NoMovies = () => (
  <div>
    <h2>No Movies Found</h2>
    <p>Please try a different search term</p>
  </div>
);

export default NoMovies;
